import { DriveStore } from "../../store/reducers";
import { TrailerAttachment } from "../../model/TrailerAttachment";
import { DataActions } from "../../store/data/actions";
import { IShipment } from "../../model/Shipment";
import { Device } from "../../model/Device";
import { UserService } from "../../utils/users";
import { ITempAssets } from "../../store/data/types";

export interface IVehicleListItem {
    name: string;
    subtitle: string;
    device: Device;
    distance?: number;
}

function getTempAssetsFromState(store: DriveStore, user: DeepReadonly<IUser> | null = null, userService: UserService) {
    let currentUser = user || userService.getCurrentUser();
    let tempAssets = currentUser && store.getState().data.tempAssets[currentUser.id];
    return tempAssets || {};
}

export function getAttachmentsFromState(store: DriveStore, userService: UserService) {
    let tempAssets = getTempAssetsFromState(store, null, userService);
    let trailerAttachments = tempAssets.trailerAttachments || [];
    return trailerAttachments.map(trailerAttachment => {
        let newAttachment = new TrailerAttachment(trailerAttachment);
        newAttachment._isTemp = true;
        return newAttachment;
    });
}

export function setAttachmentsInState(store: DriveStore, attachments: TrailerAttachment[], userService: UserService) {
    let currentUser = userService.getCurrentUser();
    let tempAssets = {...getTempAssetsFromState(store, currentUser, userService)};
    tempAssets.trailerAttachments = attachments.map(attachment => attachment.toJSON());
    currentUser && store.dispatch(DataActions.setTempAssets({ [currentUser.id]: tempAssets } as IIdDictionary<ITempAssets>));
}

export function getShipmentsFromState(store: DriveStore, userService: UserService) {
    let tempAssets = getTempAssetsFromState(store, null, userService);
    let shipments = (tempAssets.shipments || []).map(shipment => {
        let updatedShipment: DeepReadonly<IShipment> = {
            ...shipment,
            _isTemp: true
        };
        return updatedShipment;
    });
    return shipments;
}

export function setShipmentsInState(store: DriveStore, shipments: IShipment[], userService: UserService) {
    let currentUser = userService.getCurrentUser();
    let tempAssets = {...getTempAssetsFromState(store, currentUser, userService)};
    tempAssets.shipments = shipments;
    currentUser && store.dispatch(DataActions.setTempAssets({ [currentUser.id]: tempAssets } as IIdDictionary<ITempAssets>));
}

export function clearTempAssetsFromState(store: DriveStore, userService: UserService) {
    let currentUser = userService.getCurrentUser();
    currentUser && store.dispatch(DataActions.clearTempAssets(currentUser.id));
}